<!--  -->
<template>
  <div>
    <div class="msg" v-if="courseBaseData.isBuy && !buyStatus">
      无法购买：当前套餐您已购买过其中某一个课程
    </div>
    <div class="to-buy">
      <div class="left btn">
        <div class="zhiCustomBtn" @click="openChat">
          <img src="@/assets/img/productDetail/icon_custom.png" alt />
          <span class>咨询</span>
        </div>
      </div>
      <div class="btn">
        <button
          @click="toBuy"
          :class="{
            disabled: !buyBtnData.status || courseBaseData.unaleBuy,
            coupon: allAcvitity.activeType === 4,
          }"
        >
          {{ buyBtnData.btnTxt }}
          <span
            class="coupon-price"
            v-if="allAcvitity.activeType === 4 && this.$root.miniprogramBuyCourse"
          >
            <br />
            券后¥{{ allAcvitity.nowAcvitity.promotionPrice }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqAddCollected, reqCheckCollect, reqCancelCollect } from '@/api/combination';
import collected from '@/assets/img/productDetail/course-colleted.png';
import collect from '@/assets/img/productDetail/course-collet.png';
import {
  setTokenFromCookie,
  gioEnterCart,
  getRegisterSourceInfo,
  gioPlatform,
} from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { setBaseUrl } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      collect,
      collected,
      isCollect: false, // 是否收藏
      collectInfo: {}, // 当前收藏的数据
      disabled: false, // 能否点击
    };
  },
  props: {
    buyBtnData: {
      type: Object,
      default: () => {},
    },
    buyStatus: {
      type: Boolean,
      default: false,
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'allAcvitity', 'userInfo']),
    showPrice() {
      const { sellPrice } = this.courseBaseData;
      const { nowAcvitity, activeType } = this.allAcvitity;
      let salePrice = 0;
      if (activeType <= 0 || activeType === 4) {
        // 无活动
        salePrice = sellPrice;
      } else {
        // 活动价格
        salePrice = nowAcvitity?.promotionPrice;
      }
      return salePrice;
    },
    // 原价
    originalPrice() {
      const { nowAcvitity, activeType } = this.allAcvitity;
      const { originalPrice } = this.courseBaseData;
      const price = activeType <= 0 ? originalPrice : nowAcvitity.price;
      return price;
    },
  },
  mounted() {
    this.reqCollect();
  },
  methods: {
    toBuy() {
      this.$emit('tobuy');
    },
    // 是否收藏
    async reqCollect() {
      const { combinationId } = this.$route.query;
      const { data } = await reqCheckCollect(combinationId, 3);
      this.isCollect = !!data;
      this.collectInfo = data;
    },
    checkCollect() {
      const { combinationId } = this.$route.query;
      const { isCollect, collectInfo } = this;
      if (!this.userInfo?.id) {
        this.$emit('tobuy');
        return;
      }
      if (this.disabled) {
        return;
      }
      this.disabled = true;
      if (!isCollect) {
        this.addCollect(combinationId);
      } else {
        this.cancelCollect(collectInfo?.id);
      }
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    // 添加收藏
    async addCollect(combinationId) {
      const { code, msg } = await reqAddCollected({
        sourceId: combinationId,
        type: 3,
      });
      if (code === 0) {
        const { name } = this.courseBaseData;
        this.$toast(this.$root.$data.isApp ? '收藏成功' : '收藏成功，可在启航教育APP查看');
        this.reqCollect();
        gio('track', 'collect_event', {
          courseId_var: combinationId.toString(),
          courseName_var: name,
          platform_var: gioPlatform(),
        });
      } else {
        this.$toast(msg);
      }
    },
    // 取消收藏
    async cancelCollect(id) {
      const { code, msg } = await reqCancelCollect(id);
      if (code === 0) {
        this.$toast('已取消收藏');
        this.reqCollect();
      } else {
        this.$toast(msg);
      }
    },
    openChat() {
      const { baseBusinessLine } = this.courseBaseData;
      const flag = baseBusinessLine && baseBusinessLine === 2; // 判断是否专申本业务线

      const url = `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'689c302a873d7d0001e78a48'}`;

      const baseUrl = setBaseUrl(9);
      const urlH5 = `${baseUrl}/chat/m_page?probeId=${25}&token=${localStorage.getItem(
        'accessToken',
      )}&landingPageUrl=${window.location.href}`;
      const urlMini = `${baseUrl}/chat/m_page?probeId=${26}&token=${localStorage.getItem(
        'accessToken',
      )}&landingPageUrl=${window.location.href}`;

      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: flag ? url : urlH5,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        if (flag) {
          wx.miniProgram.navigateTo({
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(
              `https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'689c3a40873d7d0001e78a4c'}`,
            )}&probeId=${'689c3a40873d7d0001e78a4c'}`,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: `/subPackages/aiChatProdWebview/index?probeId=26`,
          });
        }

        return;
      }
      window.open(flag ? url : urlH5);
    },
    // 查看购物车列表
    goShoppingCar() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
            await this.$parent.getPageDetail();
          });
        } else {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/shoppingCar', beforePageName: 1 },
          });
          gioEnterCart(1);
        }
        return;
      }
      this.$router.push({
        path: '/shoppingCar',
        query: {
          beforePageName: 1,
        },
      });
      gioEnterCart(1);
    },

    // 加入套餐到购物车
    addShoppingCar() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'combinationCourse', 5, true);
        } else {
          const param = { redirect: '/combinationCourse', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
        return;
      }
      this.$emit('toShopCar');
    },
  },
};
</script>

<style lang="scss" scoped>
.msg {
  width: 100%;
  height: 72px;
  color: #ff6c02;
  font-weight: 500;
  font-size: 24px;
  line-height: 72px;
  text-align: center;
  background: #ffefe4;
}

.to-buy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 40px;
  background: #fff;

  .left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    // min-width: 200px;

    > div {
      flex-direction: column;
      padding-right: 25px;
    }
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > div {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      img {
        display: block;
        width: 47px;
        height: 47px;
      }

      span {
        color: #333;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
      }
    }

    button.mini {
      width: 400px;
    }

    button {
      width: 598px;
      height: 82px;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      background: #ff6c02;
      background: linear-gradient(90deg, #ff6c02 0%, #ff7f41 100%);
      border-radius: 41px;

      .coupon-price {
        color: #fff;
        font-size: 22px;
      }
    }

    button.coupon {
      font-size: 24px;
      line-height: 30px;
    }

    button.disabled {
      color: #fff;
      background: #ccc;
      pointer-events: none;
    }
  }
}

.addBtnGary {
  color: #fff !important;
  background: #ccc !important;
  pointer-events: none;
}

.carBuyUi {
  // border-radius: 0 45px 45px 0 !important;
}

.addShopCar {
  width: 205px;
  height: 80px;
  color: #fff;
  font-weight: 500;
  font-size: 27px;
  line-height: 80px;
  text-align: center;
  background: linear-gradient(90deg, #fed319 0%, #ffbc1f 100%);
  border-radius: 45px 0 0 45px;
}

.carIconBtn {
  position: relative;

  span {
    display: block;
    color: #333;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
  }

  .carNum {
    position: absolute;
    top: -10px;
    right: 25px;
    display: block;
    width: 30px;
    height: 30px;
    color: #fff;
    font-weight: 500;
    font-size: 18px;
    font-style: normal;
    line-height: 30px;
    text-align: center;
    background: #ff472d;
    border: 2px solid #fff;
    border-radius: 50%;
  }
}
</style>
